import { useMemo, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import parse from "html-react-parser";
import validationSchema from "./index.schema";
import LoadingButton from "components/shared/LoadingButton";
import close from "Assets/images/cross_icon.png";
// css
import styles from "./index.module.scss";
import { CustomAsyncSelect, reportDropdownStyles } from "components/Common/Common";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useLazyGetAssessmentTemplatesQuery } from "store/services/clients/reports-v2/assessmentTemplates";
import { DEFAULT_ASSESSMENT_TEMPLATE } from "config/constants";
import { cloneDeep } from "lodash";

const AddAssessmentPop = ({ data, showPopup, closePopup, onSubmit }) => {
  const [selected, setSelected] = useState(null);
  const editMode = !!data?.editMode;

  const [getAssessments, { isFetching }] = useLazyGetAssessmentTemplatesQuery();

  const initialValues = useMemo(() => {
    return {
      date: data?.assessment?.assessment_date || new Date(),
      assessment: data?.assessment?.title
        ? {
          label: data?.assessment?.title,
          value: {
            title: data?.assessment?.title,
            description: data?.assessment?.answers,
            chartData: data?.assessment?.chartData,
          }
        }
        : null,
    }
  }, [data]);

  const getAssessmentOptions = async () => {
    try {
      const data = await getAssessments({ limit: 99 }).unwrap();
      const assessments = cloneDeep(data?.records) || [];
      assessments.unshift(DEFAULT_ASSESSMENT_TEMPLATE);
      return assessments?.map(i => ({ label: i.title, value: i, }))
    } catch (error) {
      console.log("Error Getting template options", error);
    };
  };

  const handleSubmit = async (values) => {
    try {
      onSubmit(values, data?.index, editMode);
      closePopup();
    } catch (err) {
      console.error("Error saving recommendation template", err);
    }
  }

  return (
    <Modal
      show={showPopup}
      className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop add-new-assesment`}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleSubmit,
            setFieldValue,
            isSubmitting,
            errors,
            values,
          }) => (
            <Form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" , height:"100%" }}>
              {console.log("values", values)}
              {console.log("errors", errors)}
              <div className="reports-v2">
                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                  <h6 className="mb-0 section-title border-bottom-0 text-uppercase" style={{ color: "#315D99" }}>{editMode ? "Edit" : "Add an"} Assessment</h6>
                  <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                </div>
                <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                  <label
                    htmlFor=""
                    className="discharge-screen-label mt-0"
                  >
                    Date
                    {/* <RequiredFieldAstrick /> */}
                  </label>
                  <div>
                    <AppDatePicker
                      name="date"
                      className="py-2"
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <label
                    htmlFor=""
                    className="discharge-screen-label mt-0"
                  >
                    Choose an Assessment
                    {/* <RequiredFieldAstrick /> */}
                  </label>
                  <div className="">
                    <CustomAsyncSelect
                      placeholder={"Select..."}
                      loadOptions={getAssessmentOptions}
                      onChange={(selected) => setFieldValue("assessment", selected)}
                      value={values?.assessment}
                      defaultOptions={true}
                      styles={reportDropdownStyles}
                    />
                    {errors.assessment && (
                      <div className="error">
                        {errors.assessment}
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-3">
                  <label
                    htmlFor=""
                    className="discharge-screen-label mt-0"
                  >
                    Description
                    {/* <RequiredFieldAstrick /> */}
                  </label>
                  <p className="themeBlue">{parse(values?.assessment?.value?.description || "")}</p>
                </div>
              </div>
              <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                <LoadingButton
                  type="submit"
                  className="blue-btn"
                  isLoading={isSubmitting}
                >
                  {editMode ? "Save" : "Add to Report"}
                </LoadingButton>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddAssessmentPop;
